import { z } from 'zod';

export const AdicionarConvidadoSchema = z.object({
  name: z
    .string({
      required_error: 'O campo é obrigatório',
    })
    .nonempty('O campo é obrigatório')
    .min(3, 'O campo deve ter no mínimo 3 caracteres')
    .max(40, {
      message: 'O campo deve ter no máximo 40 caracteres',
    })
    .trim(),
  isAssociado: z.boolean().optional(),
});

export type AdicionarConvidadoSchemaType = z.infer<
  typeof AdicionarConvidadoSchema
>;
